import { useEffect as t, useLayoutEffect as c } from "react";
import { env as i } from '../utils/env.js';
var l = function l(e, f) {
  i.isServer ? t(e, f) : c(e, f);
};
export { l as useIsoMorphicEffect };